module.exports = __webpack_public_path__ + "media/bootstrap-icons/telephone-forward-fill-19ec6872.svg";